import React from 'react';
import PropTypes from 'prop-types';
import {FigStyle, FigCaptionStyle, CaptionStyle, StyledFigCaption} from './styled'

const Figure = ({el, wrapText, leftAlign, dimensions, altText }) => {
  const checkCustom = el.custom_width;
  const imgCaptions = el.image_caption;
  const imgHasCopyrightText = el.inset_image && el.inset_image.copyright;

  return (
    <FigStyle
      wrapText={wrapText}
      leftAlign={leftAlign}
      dimensions={dimensions && dimensions.width}
      custom={checkCustom}
      hasCaptions={imgCaptions || imgHasCopyrightText}
    >
      
      <img 
        src={el.inset_image && el.inset_image.url} 
        alt={altText} 
      />
      
      { imgCaptions && <StyledFigCaption> {imgCaptions} </StyledFigCaption> }
      { imgHasCopyrightText && <StyledFigCaption> Image: {el.inset_image.copyright} </StyledFigCaption> }

    </FigStyle>
  );
};

export default Figure;

Figure.propTypes = {
  altText: PropTypes.string,
  dimensions: PropTypes.object,
  el: PropTypes.object,
  leftAlign: PropTypes.bool,
  wrapText: PropTypes.bool
}